export default __webpack_public_path__ + "56bd2e9aed7fab8a1b40246cbaa02a8f.pdf";